import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconArchiveStyle0 = gravityIconIndividualCss;

const GravityIconArchive = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '4d8bf75137a0ab0a80be38c9f4fc157dbc96b48c', color: this.color, size: this.size }, h("svg", { key: '115dfa4564e2d46f950ea1c6393b2e6dbe8f03d6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'b2ecb88b1bf0ed8a45dc859cf84227717c3d5eac', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 3a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-15Zm14 4.5v-3h-13v3h13Z", fill: "currentColor" }), h("path", { key: '3c6b83ddf253d142fc8df5bec10d10240c638dd8', d: "M16.5 17.5v-6a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 .5.5v6h11Z", fill: "currentColor" }), h("path", { key: 'ce004e501f9efe71073b428759a78d202928e13b', d: "M8.5 12.03a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-5Z", fill: "currentColor" }))));
    }
};
GravityIconArchive.style = GravityIconArchiveStyle0;

export { GravityIconArchive as gravity_icon_archive };

//# sourceMappingURL=gravity-icon-archive.entry.js.map